/* eslint react/prop-types: 0 */
import React from 'react'
import Select from 'react-select'
import { FormInput } from 'camino-react'

const SendSurveyAction = ({
  update,
  operations: { survey_id: surveyID },
  options: { surveys }
}) => (
  <FormInput>
    <Select
      value={surveyID}
      onChange={e => update('survey_id', e.value)}
      options={surveys}
    />
  </FormInput>
)

export default SendSurveyAction
